import { render, staticRenderFns } from "./BaseH3.vue?vue&type=template&id=3fb5bc79&"
import script from "./BaseH3.vue?vue&type=script&lang=js&"
export * from "./BaseH3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports